import { useTranslation } from "react-i18next";
import {
  Container,
  ContentWrapper,
  HeadingText,
  ValueText,
  ValueWrapper
} from "./MetricCard.styles";
import { MetricCardProps } from "./MetricCard.props";
import { useMetricValue } from "../../../hooks";

export const MetricCard = ({ translationKey, value, Icon }: MetricCardProps) => {
  const { t } = useTranslation();

  const renderValue = useMetricValue(value);

  return (
    <Container>
      <ContentWrapper>
        <HeadingText>{t(translationKey)}</HeadingText>
        <ValueWrapper>
          {Icon && <Icon />}
          <ValueText>{renderValue}</ValueText>
        </ValueWrapper>
      </ContentWrapper>
    </Container>
  );
};
